import { render, staticRenderFns } from "./validation-recurrence.vue?vue&type=template&id=50b5d144"
import script from "./validation-recurrence.vue?vue&type=script&lang=js"
export * from "./validation-recurrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports